/**
 * チャット入力エリア(テキストエリア+送信ボタン+フッターヒント/リセットボタン)
 *
 * @param {Object} props
 * @param {string} props.value - テキストエリアの入力中の値（親コンポーネントが制御）
 * @param {(value: string) => void} props.onChange - テキストエリア変更時に呼ばれるハンドラ
 * @param {() => void} props.onSend - 送信ボタン押下・Enter入力時に呼ばれる送信ハンドラ
 * @param {boolean} props.disabled - 入力・送信ボタンを無効化するか（送信中・コンテキスト未確定時等）
 * @param {string} props.hint - フッターに表示するヒント/状態メッセージ
 * @param {boolean} props.isError - trueの場合、hintをエラー用スタイルで表示する
 * @param {boolean} props.showResetButton - 「新しい質問を始める」ボタンを表示するか
 * @param {() => void} props.onReset - リセットボタン押下時に呼ばれるハンドラ
 */
const ChatInputArea = ({ value, onChange, onSend, disabled, hint, isError, showResetButton, onReset }) => {
  /**
   * Enterキーで送信、Shift+Enterで改行する（一般的なチャットUIの操作感に合わせる）。
   * 入力が無効化中、または未入力（空白のみ含む）の場合は送信しない。
   * @param {React.KeyboardEvent<HTMLTextAreaElement>} e
   */
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!disabled && value.trim()) {
        onSend();
      }
    }
  };

  return (
    <div className="chat-input-area">
      <div className="chat-input-row">
        <textarea
          className="chat-textarea"
          rows={2}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          maxLength={1000}
          placeholder={'PDFの内容についてAIに質問できます\n例：3ページの表の「条件付き引受」とは？'}
        />
        <button
          type="button"
          className="chat-send-button"
          title="送信"
          disabled={disabled || !value.trim()}
          onClick={onSend}
        >
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
          </svg>
        </button>
      </div>
      <div className="chat-input-footer">
        <span className={`chat-hint${isError ? ' chat-hint-error' : ''}`}>{hint}</span>
        {showResetButton && (
          <button type="button" className="chat-new-btn" onClick={onReset}>
            🔄 新しい質問を始める
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatInputArea;
